import { render, staticRenderFns } from "./EditarConsumo.vue?vue&type=template&id=760e00d6"
import script from "./EditarConsumo.vue?vue&type=script&lang=js"
export * from "./EditarConsumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports